module.exports = __webpack_public_path__ + "img/watch0.4fb10cbe.png";